"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SubstanceSpecification_Structure = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_SubstanceSpecification_Isotope_1 = require("./RTTI_SubstanceSpecification_Isotope");
var RTTI_SubstanceSpecification_MolecularWeight_1 = require("./RTTI_SubstanceSpecification_MolecularWeight");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_SubstanceSpecification_Representation_1 = require("./RTTI_SubstanceSpecification_Representation");
exports.RTTI_SubstanceSpecification_Structure = t.recursion('ISubstanceSpecification_Structure', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        stereochemistry: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        opticalActivity: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        molecularFormula: t.string,
        _molecularFormula: RTTI_Element_1.RTTI_Element,
        molecularFormulaByMoiety: t.string,
        _molecularFormulaByMoiety: RTTI_Element_1.RTTI_Element,
        isotope: t.array(RTTI_SubstanceSpecification_Isotope_1.RTTI_SubstanceSpecification_Isotope),
        molecularWeight: RTTI_SubstanceSpecification_MolecularWeight_1.RTTI_SubstanceSpecification_MolecularWeight,
        source: t.array(RTTI_Reference_1.RTTI_Reference),
        representation: t.array(RTTI_SubstanceSpecification_Representation_1.RTTI_SubstanceSpecification_Representation)
    });
});
//# sourceMappingURL=RTTI_SubstanceSpecification_Structure.js.map